/** @format */

import React, { useState } from "react";
import cn from "classnames";
import moment from "moment/moment";
import { isMobile } from "react-device-detect";
import style from "./style.module.scss";
import CustomDatePicker from "../../shared/date-picker/Date";
import CalendarIcon from "../../shared/icons/CalendarIcon";
import CloseIconNew from "../../shared/icons/CloseIconNew";

const FilterDatePicker = ({
  date,
  isEditable = false,
  minDate,
  setDate,
  detect,
  labelText = "",
  errorDate = "",
  placeholderText = "00.00.00",
  isRange = false,
  noMarginBottom = false,
}) => {
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);

  const onChangeDate = (update) => {
    if (isRange) {
      const [start, end] = update;
      const setZeroTime = (d) => {
        if (!d) return null;
        const dateObj = new Date(d);
        dateObj.setHours(0);
        dateObj.setMinutes(0);
        dateObj.setSeconds(0);
        return dateObj;
      };

      setDate([setZeroTime(start), setZeroTime(end)]);
      if (detect) detect();
    } else {
      const dateWithZeroTime = new Date(update);
      dateWithZeroTime.setHours(0);
      dateWithZeroTime.setMinutes(0);
      dateWithZeroTime.setSeconds(0);

      setDate(dateWithZeroTime);
      if (detect) detect();
    }
  };

  const handleDatePickerChange = (update) => {
    onChangeDate(update);

    if (!isRange) {
      setIsCalendarOpen(false);
      return;
    }

    if (Array.isArray(update) && update[0] && update[1]) {
      setIsCalendarOpen(false);
    }
  };

  const handleDateFieldClick = (event) => {
    if (!isEditable || event.target.closest(".react-datepicker")) return;
    setIsCalendarOpen(true);
  };

  const handleClearClick = (event) => {
    event.stopPropagation();
    setIsCalendarOpen(false);
    isRange ? setDate([null, null]) : setDate();
  };

  const ContentItemEditable = (type) => {
    let input = "";
    if (type === "date") {
      if (isRange) {
        const [startDate, endDate] = Array.isArray(date) ? date : [null, null];
        input = (
          <CustomDatePicker
            selectsRange
            startDate={startDate}
            endDate={endDate}
            dateFormat="dd.MM.yyyy"
            placeholderText={placeholderText}
            monthsShown={1}
            minDate={minDate}
            onChange={handleDatePickerChange}
            open={isCalendarOpen}
            onClickOutside={() => setIsCalendarOpen(false)}
            withPortal={isMobile}
            showYearNavigation
            popperProps={{ strategy: "fixed" }}
          />
        );
      } else {
        input = (
          <CustomDatePicker
            selected={date}
            dateFormat="dd.MM.yyyy"
            placeholderText={placeholderText}
            monthsShown={1}
            minDate={minDate}
            onChange={handleDatePickerChange}
            open={isCalendarOpen}
            onClickOutside={() => setIsCalendarOpen(false)}
            withPortal={isMobile}
            popperProps={{ strategy: "fixed" }}
          />
        );
      }
    }

    return input;
  };

  return (
    <>
      <div>
        <div
          className={cn("d-flex align-items-center justify-content-start", {
            [style.editable]: isEditable,
            [style.errorState]: errorDate,
            [style.range]: isRange,
            [style.noMarginBottom]: noMarginBottom,
          })}
          onClick={handleDateFieldClick}
        >
          <div className={cn(style.labelInp, { [style.labelError]: errorDate })}>
            {labelText}
          </div>
          <CalendarIcon />
          {isEditable ? ContentItemEditable("date") : ContentItem("date", date, "", isRange)}
          {(isRange ? (Array.isArray(date) && (date[0] || date[1])) : date) && (
            <CloseIconNew onClick={handleClearClick} />
          )}
        </div>
        {errorDate && <div className={style.errorText}>{errorDate}</div>}
      </div>
    </>
  );
};
const ContentItem = (type = "", value, prefixStart = "", isRange = false) => {
  let text = "";

  if (type === "date") {
    if (isRange && Array.isArray(value)) {
      const startText = value[0] ? moment.utc(value[0]).format("DD.MM.YYYY") : "";
      const endText = value[1] ? moment.utc(value[1]).format("DD.MM.YYYY") : "";
      
      if (value[0] && value[1]) {
        text = `${moment.utc(value[0]).format("DD.MM")} - ${moment.utc(value[1]).format("DD.MM")}`;
      } else {
        text = startText || endText;
      }
    } else {
      text = value ? moment.utc(value).format("DD.MM.YYYY") : "";
    }
  }

  return (
    <span className="ms-1">
      {prefixStart}
      {text}
    </span>
  );
};

export default FilterDatePicker;
